import { userConstants } from '../constants';

const initialDState = {
  isFetching: false,
  dashboardList: []
}
const initialTState = {
  isFetching: false,
  templateList: []
}

export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.users
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}

export function dashboard(state = initialDState, action) {
  switch (action.type) {
    case userConstants.DASH_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        lastUpdated: action.receivedAt };
    case userConstants.DASH_LIST_RECEIVE:
      return {
        ...state,
        isFetching: false,
        dashboardList: action.dashboardList,
        lastUpdated: action.receivedAt
      };
    default:
      return state;
  }
}

export function template(state = initialTState, action) {
  switch (action.type) {
    case userConstants.TEMPLATE_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        lastUpdated: action.receivedAt };
    case userConstants.TEMPLATE_LIST_RECEIVE:
      return {
        ...state,
        isFetching: false,
        templateList: action.templateList,
        lastUpdated: action.receivedAt
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js